import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "form-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input_password = _resolveComponent("oio-input-password")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_reset_password_layout = _resolveComponent("reset-password-layout")!

  return (_openBlock(), _createBlock(_component_reset_password_layout, {
    class: "first-reset-password",
    logo: _ctx.logo,
    copyright: _ctx.copyright
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.translateValueByKey('请重置密码')), 1),
        _createVNode(_component_oio_form, _mergeProps({
          ref: "formRef",
          name: "first-reset-password",
          data: _ctx.data,
          rules: _ctx.verificationRules
        }, _ctx.formLayout, { onFinish: _ctx.onOk }), {
          default: _withCtx(() => [
            _createVNode(_component_oio_form_item, {
              name: "newPassword",
              label: _ctx.translateValueByKey('设置新密码')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_oio_input_password, {
                  placeholder: _ctx.translateValueByKey('请输入您的密码'),
                  value: _ctx.data.newPassword,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.newPassword) = $event)),
                  autocomplete: "new-password"
                }, null, 8, ["placeholder", "value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_oio_form_item, {
              name: "confirmPassword",
              label: _ctx.translateValueByKey('确认新密码')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_oio_input_password, {
                  placeholder: _ctx.translateValueByKey('请再次输入您的密码'),
                  value: _ctx.data.confirmPassword,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.confirmPassword) = $event)),
                  autocomplete: "new-password"
                }, null, 8, ["placeholder", "value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_oio_form_item, _normalizeProps(_guardReactiveProps(_ctx.formButtonLayout)), {
              default: _withCtx(() => [
                _createVNode(_component_oio_button, {
                  type: "primary",
                  "html-type": "submit",
                  loading: _ctx.loading,
                  block: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.translateValueByKey('确定')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        }, 16, ["data", "rules", "onFinish"])
      ])
    ]),
    _: 1
  }, 8, ["logo", "copyright"]))
}